import React, { FC } from 'react';

import { Container } from '@shared';

import { StyledTypograpy, Wrapper } from './styled';

interface Props {
  title: string;
}

const TopPageTitle: FC<Props> = ({ title }) => {
  return (
    <Wrapper>
      <Container>
        <StyledTypograpy>{title}</StyledTypograpy>
      </Container>
    </Wrapper>
  );
};
export default TopPageTitle;
